import { render } from "./StockPage.vue?vue&type=template&id=b294af0e"
import script from "./StockPage.vue?vue&type=script&lang=js"
export * from "./StockPage.vue?vue&type=script&lang=js"

import "./StockPage.vue?vue&type=style&index=0&id=b294af0e&lang=css"
script.render = render

export default script